import storeEvent from "../../utils/store-event";
import { get } from "../../utils/object-helpers";

class {
    onInput(input) {
        const overflow = get(input, 'page.modules.PRESENCE_INFORMATION_MODULE.overflowButton', null);
        return {
            overflow,
            a11yText: get(overflow, 'offCallToAction.text', '')
        }
    }
    openDrawer() {
        storeEvent.openOverflowDrawer.dispatch();
    }
}

<if(input.overflow)>
    <ebay-icon-button
        aria-label=input.a11yText
        on-click("openDrawer")
        class="str-overflow-button">
        <ebay-overflow-vertical-16-icon/>
    </ebay-icon-button>
</if>
